import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  IconButton,
  Image,
  Text,
  useDisclosure
} from '@chakra-ui/react';
import { Link, navigate } from 'gatsby';
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import Icon from '../../../atoms/Icon/Icon';
import * as styles from './MobileDrawerContent.module.scss';
const MobileDrawerContent = ({ data, onCloseModal }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [secondLevel, setSecondLevel] = useState(undefined);


  const linkClickHandler = activeMenu => {
    setSecondLevel(activeMenu);
    onOpen();
  };
  

  return (
    <section className={styles.root}>
      <div className="first-level-menu">
        <div className="top-actions">
          <div>
            {isOpen && (
              <Button
                onClick={onClose}
                leftIcon={<Icon symbol={'arrowWithTail'} />}
                variant={'ghost'}
              >
                Back
              </Button>
            )}
          </div>
          <IconButton
            variant={'ghost'}
            icon={<Icon symbol={'close'} />}
            onClick={onCloseModal}
          />
        </div>
        {!isOpen && (
        <div className='link-container'>
   
      
            <div className={'links'}>
              
              {data?.map((item, index) => (
                <button
                  key={index}
                  className="links-parent"
                  onClick={
                    item.headerLinksItem.subList
                      ? () => linkClickHandler(item.headerLinksItem)
                      : () => navigate(item.headerLinksItem.link)
                  }
                >
                  <Flex gap={4} alignItems={'center'}>
                    {item.headerLinksItem.logo && (
                      <Image
                        src={item.headerLinksItem.logo}
                        alt={item.headerLinksItem.name}
                      />
                    )}
                    <span> {item.headerLinksItem.name}</span>
                  </Flex>
                  {item.headerLinksItem.subList && (
                    <div>
                      <Icon symbol={'chevRight'} />
                    </div>
                  )}
                </button>
              ))}
            </div>
              <div className="account">
                <Link to="/account">
                  <Icon symbol={'user'} />
                  <span>account</span>
                </Link>
                <Link to="https://petchemist.brainfish.ai/" target='_blank'>
                  <Icon symbol={'contact'} />
                  <span>contact us</span>
                </Link>
                <Link to="/landing/medication">
                  <Icon symbol={'small-box'} />
                  <span>ordering medication</span>
                </Link>
              </div>
              </div>
            )}

        {
          <CSSTransition
            in={isOpen}
            onExit={() => setSecondLevel([])}
            timeout={300}
            classNames="slide"
            unmountOnExit
            //   onEnter={() => setSecondLevel(links)}
          >
            <div className="second-level-menu">
              <div className="top-label">
                <span>Shop All</span>

                {secondLevel?.link ? (
                  <Text as={Link} to={secondLevel.link}>
                    {secondLevel?.name}
                  </Text>
                ) : (
                  <p>{secondLevel?.name}</p>
                )}
              </div>
              <Accordion
                paddingInlineStart={0}
                paddingInlineEnd={0}
                maxH={'calc(100dvh - 153px)'}
                overflow={'auto'}
                p={'0'}
                allowToggle
                px={4}
              >
                {secondLevel?.subList?.map((item, index) => (
                  <React.Fragment key={index}>
                    {item.innerList?.length > 0 ? (
                      <AccordionItem px={0}>
                        <AccordionButton
                          py={4}
                          display={'flex'}
                          justifyContent={'space-between'}
                          alignItems={'center'}
                        >
                          {item.title}
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel
                          py={4}
                          className={styles.accordionPanel}
                          overflowY={'auto'}
                        >
                            {item?.link &&
                                      
                                      <button
                                        className={`${styles.viewAll} underline`}
                                        onClick={() => {
                                          navigate(item.link);
                                          onCloseModal();
                                        }}
                                      >
                                        View All
                                      </button>
                                    }
                          {item?.innerList?.map((item, index) => (
                            <React.Fragment key={index}>
                              <div>
                                <p>{item.title}</p>
                                {/* {item.imageMode ? (
                                  <ul className={styles.imageMode}>
                                    {item?.links?.map((item, index) => (
                                      <li key={index}>
                                        <button
                                          onClick={() => {
                                            navigate(item.url);
                                            onCloseModal();
                                          }}
                                        >
                                          <Image
                                            src={item.image}
                                            alt={item.text}
                                          />
                                        </button>
                                      </li>
                                    ))}
                                  </ul> 
                                // ) : (*/}
                                  <ul className={styles.textMode}>
                                    {item?.links?.map((item, index) => (
                                      <li key={index}>
                                        <button
                                          className="underline"
                                          onClick={() => {
                                            navigate(item.url);
                                            onCloseModal();
                                          }}
                                        >
                                          {item.text}
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                 {/* )} */}
                              </div>
                            </React.Fragment>
                          ))}
                        </AccordionPanel>
                      </AccordionItem>
                    ) : (
                      <Box
                        p={4}
                        className="default-hover"
                        as={Link}
                        to={item.link}
                        display={'block'}
                      >
                        {item.title}
                      </Box>
                    )}
                  </React.Fragment>
                ))}
              </Accordion>
            </div>
          </CSSTransition>
        }
      </div>

  
    </section>
  );
};

export default MobileDrawerContent;
